import useAuth from '@scripts/frontend/hooks/useAuth'
import Unauthorized from '@shared/screens/Unauthorized'
import { Outlet } from 'react-router-dom'

import { SideBarMenu } from '../partials/my-account/SideBarMenu'

export function MyAccountTemplate() {
  const { isLoggedIn } = useAuth()

  if (!isLoggedIn) {
    return <Unauthorized />
  }

  return (
    <div className="md:flex">
      <SideBarMenu />
      <div className="-mx-8 flex min-h-[60vh] w-full max-w-full flex-col p-10 md:mx-0 md:flex-1">
        <Outlet />
      </div>
    </div>
  )
}

export default MyAccountTemplate
